import React from 'react';

import { useCXI } from 'modules/cxi/useCXI';
import * as Styled from './StyledMatchAction';

export const MatchActionMentoringContribution = ({ match }) => {
    const { setModal } = useCXI();

    return (
        <Styled.MatchAction
            className="icon-only options"
            onClick={() => setModal({ match, modal: 'ContributionAdd' })}
        >
            <span className="icon fas fa-fw fa-comment-alt-plus" aria-hidden="true" />
        </Styled.MatchAction>
    );
};
